import React from "react";
import "../App.css";
import { styled } from "@mui/system";
import { Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";
import {
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_SIZE_MD,
  FONT_WEIGHT_MEDIUM,
  MAX_WIDTH,
} from "../config/styles";
import { colors } from "../config/colors";

const CustomTableFooterStyled = styled("div")(({ theme }) => ({
  display: DISPLAY_FLEX,
  padding: "16px 40px",
  flexDirection: FLEX_DIRECTION_ROW,
  justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  "& .divRow": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
  },
  "& .MuiSelect-root": {
    ...theme.typography.subtitle2,
  },
  "& .mui-menu-item": {
    ...theme.typography.subtitle2,
    "&:hover": {
      background: theme.palette.background.default,
    },
    "&.active": {
      background: theme.palette.background.default,
    },
  },
  '& .paginationButton ': {
    border: 'none',
    margin: '0px'
  }
}));

export const CustomTableFooter = ({
  pageNo,
  pageSize,
  totalCount,
  onPageSizeChanged,
  onLeftArrow,
  onRightArrow,
}) => {
  const fromNo = pageNo * pageSize + 1;
  let toNo = pageNo * pageSize + pageSize;
  if (toNo > totalCount) toNo = totalCount;
  let toNoRight = pageNo * pageSize + pageSize;
  if (toNoRight > totalCount) toNoRight = totalCount;
  const isLeftDisabled = totalCount === 0 || pageNo === 0;
  const leftIconCss = isLeftDisabled
    ? "notificationLeftArrowDisabled"
    : "notificationLeftArrow";
  const isRightDisabled = totalCount === 0 || toNoRight === totalCount;
  const rightIconCss = isRightDisabled
    ? "notificationRightArrowDisabled"
    : "notificationRightArrow";

  const FOOTER_LIST = [
    {
      label: "10 Items",
      value: 10,
    },
    {
      label: "20 Items",
      value: 20,
    },
    {
      label: "30 Items",
      value: 30,
    },
    {
      label: "All Items",
      value: totalCount,
    },
  ];

  return (
    <CustomTableFooterStyled>
      <div
        className="divRow"
        style={{
          alignItems: FLEX_ALIGN_CENTER,
          justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
        }}
      >
        <FormControl variant="outlined" className="formControlCss">
          <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel>
          <Select value={pageSize} onChange={onPageSizeChanged}>
            {FOOTER_LIST.map((item) => (
              <MenuItem
                key={item.label}
                sx={{
                  width: MAX_WIDTH,
                  fontWeight: FONT_WEIGHT_MEDIUM,
                  fontSize: FONT_SIZE_MD,
                  color: colors.custom,
                }}
                value={item.value}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="divRow" style={{ alignItems: FLEX_ALIGN_CENTER }}>
        {totalCount > 0 && (
          <Typography variant="h4" component="label">
            Showing {fromNo} - {toNo} of {totalCount}
          </Typography>
        )}
        <div style={{ width: 16 }} />

        <button
          className={`paginationButton ${leftIconCss}`}
          onClick={isLeftDisabled ? null : onLeftArrow}
          onKeyDown={
            isLeftDisabled ? null : (e) => e.key === "Enter" && onLeftArrow()
          }
          tabIndex={isLeftDisabled ? -1 : 0}
        />
        <div style={{ width: 8 }} />
        <button
          className={`paginationButton ${rightIconCss}`}
          onClick={isRightDisabled ? null : onRightArrow}
          onKeyDown={
            isRightDisabled ? null : (e) => e.key === "Enter" && onRightArrow()
          }
          tabIndex={isRightDisabled ? -1 : 0}
        />
      </div>
    </CustomTableFooterStyled>
  );
};

CustomTableFooter.propTypes = {
  pageNo: PropTypes.number,
  pageSize: PropTypes.number,
  totalCount: PropTypes.number,
  onPageSizeChanged: PropTypes.func,
  onLeftArrow: PropTypes.func,
  onRightArrow: PropTypes.func,
};
